import View from "./view";
import previewView from "./previewView";
import icons from '../../img/icons.svg';


class ResultsView extends View{
    _parentElement = document.querySelector('.results')
    _errorMessage = 'No recipes found for your query'
    _message = ''


    _generateMarkUp(){
        return this._data.map(result => previewView.render(result, false)).join('')
    }

    // _generateMarkUpPreview(result){
    //     const id = window.location.hash.slice(1)
    //     return `
    //         <li class="preview">
    //             <a class="preview__link ${ result.id === id ? 'preview__link--active' : ''}" href="#${result.id}">
    //             <figure class="preview__fig">
    //                 <img src="${result.image}" alt="${result.title}" />
    //             </figure>
    //             <div class="preview__data">
    //                 <h4 class="preview__title">${result.title}</h4>
    //                 <p class="preview__publisher">${result.publisher}</p>
    //             </div>
    //             </a>
    //       </li>
    //     `
    // }

    // addHandlerRender(handler){
    //     _parentElement.addEventListener('click', handler)
    // }
}

export default new ResultsView()